import Row from './Row.js';

export default class Label extends Row {
  constructor(props) {
    super(props);
    this.label = null;
  }

  build() {
    const { chart } = this.props;

    this.label = chart
      .selectAll('.row-group')
      .append('text')
      .text((d) => d.title)
      .attr('class', (d) =>
        !['project', 'portfolio', 'parentPortfolio'].includes(d.type)
          ? 'chart-label'
          : 'chart-label divider'
      )
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'central')
      .attr('opacity', (d) => (this.isLabelOverflowing(d) ? 0 : 1))
      .attr('x', (d) => this.getLabelX(d))
      .attr('y', (d) => this.getLabelY(d));
  }

  update() {
    this.label
      .transition()
      .duration(this.transitionDuration)
      .attr('opacity', (d) => (this.isLabelOverflowing(d) ? 0 : 1))
      .attr('x', (d) => this.getLabelX(d));
  }

  getLabelX(datum) {
    const visibleWidth = this.getVisibleWidth(datum);
    if (['project', 'portfolio', 'parentPortfolio'].includes(datum.type)) {
      return Math.round(
        this.getVisibleStartX(datum) +
          this.getEstimatedTextWidth(datum) / 2 +
          16
      );
    }

    if (visibleWidth > 0) {
      return this.getVisibleStartX(datum) + visibleWidth / 2;
    }

    return this.getStartX(datum) + this.getWidth(datum) / 2;
  }

  getLabelY(datum) {
    const { type } = datum;
    if (['project', 'portfolio', 'parentPortfolio'].includes(type)) {
      return this.getStartY(datum) + this.props.options[`${type}BarHeight`] / 2;
    }
    return this.getStartY(datum) + this.props.options.initiativeBarHeight / 2;
  }

  getEstimatedTextWidth(datum) {
    return datum.title.length * 6;
  }

  isLabelOverflowing(datum) {
    return this.getEstimatedTextWidth(datum) + 16 > this.getVisibleWidth(datum);
  }
}
